import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  HorizontalLine,
  PageNumberContainer,
  PaginationButton,
  PaginationContainer,
} from './pagination.styles';

interface PaginationProps {
  page: number;
  totalPages: number;
  total: number;
  startIndex: number;
  endIndex: number;
  handlePrev: React.MouseEventHandler<HTMLButtonElement>;
  handleNext: React.MouseEventHandler<HTMLButtonElement>;
  mt?: string;
}

const Pagination = ({
  page,
  totalPages,
  total,
  startIndex,
  endIndex,
  handlePrev,
  handleNext,
  mt,
}: PaginationProps) => {
  return (
    <PaginationContainer marginTop={mt ?? 0}>
      <PaginationButton
        onClick={handlePrev}
        disabled={page === 1}
        aria-label="Go to previous page"
      >
        <ArrowBackIosNewIcon fontSize="small" />
      </PaginationButton>
      <PageNumberContainer data-testid="page-number-container">
        {startIndex} <HorizontalLine /> {endIndex} {`(${total})`}
      </PageNumberContainer>

      <PaginationButton
        onClick={handleNext}
        disabled={page === totalPages}
        aria-label="Go to next page"
      >
        <ArrowForwardIosIcon fontSize="small" />
      </PaginationButton>
    </PaginationContainer>
  );
};

export default Pagination;
